export const reportError = {
  reportError: {
    reportError: "Reportar erro",
    tellUs: "Conte nos...",
    whatHappened: "O que aconteceu?",
    feedback: "Feedback",
  },
};
